import { useParams } from 'react-router-dom';
import React, { useEffect, useState } from 'react';

import { useApi } from '../../util/lib';
import HtmlHead from '../UI/Head/HtmlHead';

import css from '../RpryShrtly/RpryShrtly.module.css';

export const RpryMedia = () => {
  const [pristine, setPristine] = useState(true)
  const [error, setError] = useState()
	const api = useApi();
  const { code } = useParams();
  useEffect(() => {
    const resolveMediaLink = async () => {
      try {
        if (!pristine) return
        setPristine(false)
        const response = await api({
          method: 'get',
          responseType: 'json',
          url: `/sdk/shrtly/${code}`,
        });
        if (response.data && response.data.originalUrl) {
          window.location.href = response.data.originalUrl;
        } else {
          throw new Error('No URL found');
        }
      } catch (error) {
        console.error(error)
        setError(error)
      }
    }
    resolveMediaLink();
  }, [api, code, pristine])
  return (
    <>
      <HtmlHead repairy />

      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh'
      }}>
        {error && (
          <p>
            Opps! Seems like we cant provide you a service now. 
            Please contact support if problem persists
          </p>
        )}
        {!error && (
          <img
            alt='rpry-icon'
            src='/rpry-icon.svg'
            className={css.RpryLogo} />
        )}
      </div>
    </>
  );
}
